import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import GlassButton from '../ui/GlassButton';
import { cn } from '../../utils/cn';

export default function Navbar() {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const { scrollY } = useScroll();

    // Transform opacity based on scroll
    const navBackground = useTransform(
        scrollY,
        [0, 50],
        ['rgba(5, 5, 5, 0)', 'rgba(5, 5, 5, 0.8)']
    );

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <motion.nav
            style={{ backgroundColor: navBackground }}
            className={cn(
                "fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-sm border-b",
                scrolled ? "border-white/[0.08]" : "border-transparent"
            )}
        >
            <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative">
                {/* Logo */}
                <div
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="flex items-center gap-3 cursor-pointer group"
                >
                    <img src="/logo.png" alt="PitchMe.AI" className="w-10 h-10 rounded-xl shadow-[0_0_20px_rgba(255,255,255,0.2)] group-hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] transition-all duration-300" />
                    <span className="text-xl font-bold tracking-tight text-white">
                        PitchMe<span className="text-zinc-500">.AI</span>
                    </span>
                </div>

                {/* Desktop Navigation (Centered) */}
                <div className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
                    <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">Features</button>
                    <button onClick={() => document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">How it Works</button>
                    <button onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm font-medium text-zinc-400 hover:text-white transition-colors">Pricing</button>
                </div>

                {/* CTA */}
                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate('/login')}
                        className="text-sm font-medium text-white hover:text-zinc-300 transition-colors hidden sm:block"
                    >
                        Sign In
                    </button>
                    <GlassButton
                        variant="primary"
                        size="sm"
                        onClick={() => navigate('/login')}
                    >
                        Get Started
                        <i className="ri-arrow-right-line"></i>
                    </GlassButton>
                </div>
            </div>
        </motion.nav>
    );
}
